<div class="xi-modal__container group-create__container" *transloco="let t">
  <h2 class="xi-modal__title group-create__title">{{ t('group-create-dialog.title') }}</h2>
  <form (ngSubmit)="create()">
    <div class="xi-modal__content">
      <div class="group-create__name">
        <xi-input-field
          appAutoFocus="xiInput"
          [formControl]="groupName"
          label="{{ t('group-create-dialog.group-name') }}"
          placeholder="{{ t('group-create-dialog.placeholder') }}"
          icon="cancel"
          [status]="groupNameStatus"
          (onChange)="onValidateGroupName()"
          (onIconClick)="groupName.patchValue(''); onValidateGroupName()"
        ></xi-input-field>
      </div>
    </div>
    <div class="xi-modal__actions">
      <xi-default-button
        type="button"
        text="{{ t('group-create-dialog.cancel') }}"
        fill="text"
        (onClick)="cancel()"
      ></xi-default-button>

      <xi-default-button
        text="{{ t('group-create-dialog.create') }}"
        [disabled]="groupName.invalid"
      ></xi-default-button>
    </div>
  </form>
</div>
